/**
 * Единый инстанс vue-i18n. Вынесен из main.ts в отдельный модуль, чтобы его можно
 * было использовать ВНЕ компонентов (например, в гарде роутера для toast'ов) без
 * циклического импорта main → router → main.
 */
import { createI18n } from "vue-i18n";
import ru from "./locales/ru.json";
import en from "./locales/en.json";

export const i18n = createI18n({
  legacy: false,
  locale: "ru",
  fallbackLocale: "en",
  messages: { ru, en },
  // Русское склонение для plural-сообщений с pipe-формами
  // «{n} ответов | {n} ответ | {n} ответа | {n} ответов» (zero|one|few|many):
  // без этого «1 ответов» вместо «1 ответ». Влияет только на ключи, переведённые
  // в pipe-форму; обычные сообщения не затрагиваются.
  pluralRules: {
    ru(choice: number, choicesLength: number): number {
      if (choice === 0) return 0;
      const mod10 = choice % 10;
      const mod100 = choice % 100;
      // «Тиновые» 11–14 / 111–114 → many (проверка по % 100, не по самому числу).
      const one = mod10 === 1 && mod100 !== 11;
      const few = mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14);
      if (choicesLength < 4) return one ? 1 : 2; // 3-форма [other|one|few-many]
      return one ? 1 : few ? 2 : 3; // 4-форма [zero|one|few|many]
    },
  },
});

/** Перевод вне компонентов (роутер-гард и т.п.). */
export function t(key: string, named?: Record<string, unknown>): string {
  return i18n.global.t(key, named ?? {});
}
